import { useContext } from "react";
import { AuthContext } from "@CONTEXTS";
import { Row, Col, Form, Input, InputNumber } from "antd";

const CreateProduct = ({ form }) => {
  const { info } = useContext(AuthContext);
  return (
    <>
      <Row gutter={24}>
        <Col span={12}>
          <Form.Item
            name={"code"}
            label="Kod:"
            rules={[
              {
                required: true,
                message: "Lütfen geçerli kod giriniz!",
              },
              {
                validator: (_, value) => {
                  if (!value) return Promise.resolve();

                  const trimmedValue = value.trim();

                  if (trimmedValue.length === 0) {
                    return Promise.reject(
                      new Error(
                        "Sadece boşluk girilemez, lütfen geçerli kod giriniz!"
                      )
                    );
                  }
                  if (trimmedValue.length < 2) {
                    return Promise.reject(
                      new Error(
                        "Kod alanı boşluklar hariç en az 2 karakter olmalıdır!"
                      )
                    );
                  }
                  if (trimmedValue.length > 30) {
                    return Promise.reject(
                      new Error("Kod alanı maksimum 30 karakter olmalıdır!")
                    );
                  }

                  return Promise.resolve();
                },
              },
            ]}
          >
            <Input maxLength={30} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name={"name"}
            label="Malzeme/Ürün Adı:"
            rules={[
              {
                required: true,
                message: "Lütfen geçerli malzeme/ürün adı giriniz!",
              },
              {
                validator: (_, value) => {
                  if (!value) return Promise.resolve();

                  const trimmedValue = value.trim();

                  if (trimmedValue.length === 0) {
                    return Promise.reject(
                      new Error(
                        "Sadece boşluk girilemez, lütfen geçerli malzeme/ürün adı giriniz!"
                      )
                    );
                  }
                  if (trimmedValue.length < 3) {
                    return Promise.reject(
                      new Error(
                        "Malzeme/ürün adı alanı boşluklar hariç en az 3 karakter olmalıdır!"
                      )
                    );
                  }
                  if (trimmedValue.length > 150) {
                    return Promise.reject(
                      new Error(
                        "Malzeme/ürün adı alanı maksimum 150 karakter olmalıdır!"
                      )
                    );
                  }

                  return Promise.resolve();
                },
              },
            ]}
          >
            <Input maxLength={150} />
          </Form.Item>
        </Col>
        {info?.desiCalculationMode !== "DESI_ONLY" && (
          <>
            <Col span={8}>
              <Form.Item
                name="width"
                label="En:"
                rules={[
                  {
                    required: true,
                    message: "Lütfen en giriniz!",
                  },
                  {
                    type: "number",
                    min: 1,
                    max: 10000,
                    message: "En değeri 1 ile 10000 arasında olmalıdır!",
                  },
                ]}
              >
                <InputNumber style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="length"
                label="Boy:"
                rules={[
                  {
                    required: true,
                    message: "Lütfen boy giriniz!",
                  },
                  {
                    type: "number",
                    min: 1,
                    max: 10000,
                    message: "Boy değeri 1 ile 10000 arasında olmalıdır!",
                  },
                ]}
              >
                <InputNumber style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="height"
                label="Yükseklik:"
                rules={[
                  {
                    required: true,
                    message: "Lütfen yükseklik giriniz!",
                  },
                  {
                    type: "number",
                    min: 1,
                    max: 10000,
                    message: "Yükseklik değeri 1 ile 10000 arasında olmalıdır!",
                  },
                ]}
              >
                <InputNumber style={{ width: "100%" }} />
              </Form.Item>
            </Col>
          </>
        )}
        <Col span={8}>
          <Form.Item
            name="desi"
            label="Desi:"
            rules={[
              {
                required: info?.desiCalculationMode === "DESI_ONLY",
                message: "Lütfen desi giriniz!",
              },
              info?.desiCalculationMode === "DESI_ONLY" && {
                type: "number",
                min: 1,
                max: 10000,
                message: "Desi değeri 1 ile 10000 arasında olmalıdır!",
              },
            ].filter(Boolean)}
          >
            <InputNumber
              style={{ width: "100%" }}
              disabled={
                info?.desiCalculationMode !== "DESI_ONLY" ? true : false
              }
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="weight"
            label="Ağırlık:"
            rules={[
              {
                required: true,
                message: "Lütfen ağırlık giriniz!",
              },
              {
                type: "number",
                min: 1,
                max: 10000,
                message: "Ağırlık değeri 1 ile 10000 arasında olmalıdır!",
              },
            ]}
          >
            <InputNumber style={{ width: "100%" }} />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

export default CreateProduct;
